export default __webpack_public_path__ + "static/media/step1.22f71976.svg";